<div id="planograms-content">
  <!-- <h1 style="padding-left: 20px;">Planograms</h1> -->
  <!-- <mat-grid-list class="planogram-list-grid" cols="6">

        <mat-grid-tile colspan="5"> -->
  <div
    style="
      display: flex;
      margin-bottom: 15px;
      justify-content: flex-end;
      font-size: 12px;
      font-weight: 500;
    "
  >
    <!-- <div style="margin-right: auto; font-size: 1.2vw; font-weight: 800">
      Planogram Library
    </div> -->
    <button
      *ngIf="isUserAdmin == 1"
      mat-raised-button
      color="warn"
      style="margin: 0 5px"
      (click)="openAdminPanel()"
    >
      Admin Panel
    </button>
    <button
      mat-raised-button
      color="warn"
      style="margin: 0 5px"
      (click)="addNewPlanogram()"
      *ngIf="false"
    >
      <!-- <em class="bi bi-plus-circle-fill"></em> -->
      Create New
    </button>
    <!-- <mat-divider></mat-divider> -->
    <button
      *ngIf="dataSource.data.length > 0"
      mat-raised-button
      color="warn"
      style="margin-right: 20px"
      (click)="openComparePlanogramDialog()"
    >
      <!-- <em class="bi bi-eye"></em> -->
      Compare Now
    </button>
  </div>
  <div style="width: 100%; height: 100%" class="planogram-wrapper">
    <div class="card">
      <div>
        <div class="filter-container">
          <!-- Channel Filter -->
          <label>Channel:</label>
          <mat-form-field class="filter-dropdown">
            <mat-select
              class="planogram-filter-select"
              [(ngModel)]="selectedChannels"
              (selectionChange)="onSelectionChange()"
              multiple
            >
              <mat-option>
                <mat-checkbox
                  class="mat-accent"
                  [checked]="allChannelsSelected"
                  (change)="toggleAllChannels()"
                  (click)="$event.stopPropagation()"
                >
                  All
                </mat-checkbox>
              </mat-option>
              <mat-option
                *ngFor="let channel of new_channels"
                [value]="channel"
              >
                <mat-checkbox
                  class="mat-accent"
                  [checked]="selectedChannels.includes(channel)"
                >
                  {{ channel }}
                </mat-checkbox>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Cooler Type Filter -->
          <label style="margin-left: 13px">Cooler Type:</label>
          <mat-form-field class="filter-dropdown">
            <mat-select
              class="planogram-filter-select"
              [(ngModel)]="selectedCoolerTypes"
              (selectionChange)="onSelectionChange()"
              multiple
            >
              <mat-option>
                <mat-checkbox
                  class="mat-accent"
                  [checked]="allCoolerTypesSelected"
                  (change)="toggleAllCoolerTypes()"
                  (click)="$event.stopPropagation()"
                >
                  All
                </mat-checkbox>
              </mat-option>
              <mat-option *ngFor="let type of new_coolerTypes" [value]="type">
                <mat-checkbox
                  class="mat-accent"
                  [checked]="selectedCoolerTypes.includes(type)"
                >
                  {{ type }}
                </mat-checkbox>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Unit Filter -->
          <label style="margin-left: 13px">Unit:</label>
          <mat-form-field class="filter-dropdown">
            <mat-select
              class="planogram-filter-select"
              [(ngModel)]="selectedUnits"
              (selectionChange)="onSelectionChange()"
              multiple
            >
              <mat-option>
                <mat-checkbox
                  class="mat-accent"
                  [checked]="allUnitsSelected"
                  (change)="toggleAllUnits()"
                  (click)="$event.stopPropagation()"
                >
                  All
                </mat-checkbox>
              </mat-option>
              <mat-option *ngFor="let unit of new_units" [value]="unit">
                <mat-checkbox
                  class="mat-accent"
                  [checked]="selectedUnits.includes(unit)"
                >
                  {{ unit }}
                </mat-checkbox>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <div class="planogram-cards">
            <ng-container
              *ngFor="let planogram of filteredPlanograms; let i = index"
            >
              <div class="planogram-card">
                <div class="planogram-lists">
                  <div *ngIf="showVerticalLine(i)" class="vertical-line"></div>
                  <div style="width: 106px" class="planogram-img">
                    <img
                      (click)="moveToReview(planogram)"
                      [src]="
                        planogram.imageUrl
                          ? planogram.imageUrl
                          : '../../assets/dummy_cooler.png'
                      "
                      alt="Planogram Image"
                      [ngClass]="
                        planogram.cooler_type === '45 Caser' &&
                        planogram.planogram_image_uri
                          ? 'planogram-lg-img'
                          : ''
                      "
                    />
                  </div>
                  <div class="planogram-details">
                    <div>
                      <div class="detail-info">
                        <span class="detail-label">Channel:</span>
                        <span class="detail-data">{{ planogram.channel }}</span>
                        <!-- <span class="detail-data">Grocery+Convenience</span> -->
                        <span class="detail-label">Cooler Type:</span>
                        <span class="detail-data">{{
                          planogram.cooler_type
                        }}</span>
                        <span class="detail-label">Unit:</span>
                        <span class="detail-data">{{ planogram.unit }}</span>
                        <span class="detail-label">Last Updated:</span>
                        <span class="detail-data">{{
                          planogram.updated_at | date : "dd/MM/yyyy"
                        }}</span>
                      </div>
                    </div>
                    <button
                      class="update-available-btn"
                      (click)="updatePlanogram(planogram)"
                      [disabled]="planogram.update_available===0"
                      [ngClass]="
                        planogram.update_available === 1
                          ? 'update-active-btn'
                          : ''
                      "
                    >
                      <img
                        style="margin-right: 8px"
                        [src]="
                          planogram.update_available === 1
                            ? '../../assets/update_check.svg'
                            : '../../assets/update_available_dark.svg'
                        "
                      />
                      New Update Available
                    </button>
                    <button
                      (click)="moveToGuidelines(planogram)"
                      class="guidelines-btn"
                    >
                      <img
                        style="margin-right: 6px"
                        src="../../assets/guideline_check.svg"
                      />
                      View Guidelines
                    </button>
                  </div>
                  <!-- <div *ngIf="(i + 1) % 3 !== 0" class="vertical-line"></div> -->
                </div>
              </div>
              <div *ngIf="(i + 1) % 3 === 0" class="horizontal-line"></div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="false" id="planograms-list-container">
    <!-- <div class="navbar-container" style="height: 50px;">
                    <nav class="navbar navbar-expand-lg navbar-light" style="height: 100%;">

                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul class="navbar-nav mr-auto">
                                <li class="nav-item" *ngFor="let tab of tabs" [routerLink]="tab.path"
                                    routerLinkActive="tab === active_tab"
                                    (click)="tab.name !== active_tab ? handleActiveTab(tab.name) : null">
                                    <a class="nav-link" [ngClass]="{'active': tab.name === active_tab}">{{tab.name}}</a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div> -->
    <div style="width: 100%; height: calc(100%)">
      <div
        class="search"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
        "
      >
        <mat-form-field appearance="outline" class="planogram-search-input">
          <mat-icon
            style="font-size: 15px; color: #0b0e1e; opacity: 30%"
            matPrefix
            >search</mat-icon
          >
          <input
            matInput
            type="text"
            [(ngModel)]="search_input"
            placeholder="Search"
            (ngModelChange)="updateFilter($event)"
          />
          <!-- <em class="bi bi-funnel"></i> -->
        </mat-form-field>
      </div>

      <div style="width: 100%; height: calc(100% - 60px); overflow: auto">
        <!-- <ng-template #mytable let-planograms="data_source" [ngTemplateOutlet]="mytable"
                            [ngTemplateOutletContext]="{data_source: getDataSource()}"> -->
        <table
          [formGroup]="planogram_list_form_group"
          id="planogram-list-table"
          mat-table
          *ngIf="dataSource.data.length > 0"
          aria-describedby=""
          [dataSource]="dataSource"
          #mytable
          class="my-table mat-elevation-z8"
        >
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th style="width: 14vw" mat-header-cell *matHeaderCellDef>
              <mat-form-field *ngIf="planogramNames.length > 0">
                <mat-label>Planogram Name</mat-label>
                <mat-select
                  value="planogram_list_form_group['planogram_name'].value"
                  formControlName="planogram_name"
                  multiple
                >
                  <mat-option
                    (click)="toggleSelection(name, 'planogram_name', 0)"
                    *ngFor="let name of planogramNames"
                    [value]="name"
                  >
                    {{ name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let planogram">{{ planogram.name }}</td>
          </ng-container>

          <ng-container matColumnDef="unit">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field *ngIf="units.length > 0">
                <mat-label>Unit</mat-label>
                <mat-select
                  value="planogram_list_form_group['unit'].value"
                  formControlName="unit"
                  multiple
                >
                  <mat-option
                    (click)="toggleSelection(unit, 'unit', 1)"
                    *ngFor="let unit of units"
                    [value]="unit"
                  >
                    {{ unit }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let planogram">{{ planogram.unit }}</td>
          </ng-container>

          <!-- Channel Column -->
          <ng-container matColumnDef="channel">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field *ngIf="channels.length > 0">
                <mat-label>Channel</mat-label>
                <mat-select
                  value="planogram_list_form_group['channel'].value"
                  formControlName="channel"
                  multiple
                >
                  <mat-option
                    (click)="toggleSelection(channel, 'channel', 2)"
                    *ngFor="let channel of channels"
                    [value]="channel"
                  >
                    {{ channel }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let planogram">
              {{ planogram.channel }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cooler_type">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field *ngIf="coolerTypes.length > 0">
                <mat-label>Cooler Type</mat-label>
                <mat-select
                  value="planogram_list_form_group['cooler_type'].value"
                  formControlName="cooler_type"
                  multiple
                >
                  <mat-option
                    (click)="toggleSelection(cooler, 'cooler_type', 3)"
                    *ngFor="let cooler of coolerTypes"
                    [value]="cooler"
                  >
                    {{ cooler }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let planogram">
              {{ planogram.cooler_type }}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="transaction_percentage">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Transaction % </th>
                                <td mat-cell *matCellDef="let planogram"> {{planogram.transaction_percentage}} </td>
                            </ng-container> -->

          <ng-container matColumnDef="cooler_value">
            <th mat-header-cell *matHeaderCellDef>One Turn Value</th>
            <td mat-cell style="font-weight: 600" *matCellDef="let planogram">
              ₹ {{ planogram.cooler_value }}
            </td>
          </ng-container>

          <!-- Sub Channel Column -->
          <!-- <ng-container matColumnDef="sub_channel">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Sub-Channel </th>
                                <td mat-cell *matCellDef="let planogram"> {{planogram.sub_channel.value}} </td>
                            </ng-container> -->

          <!-- Business Goals Column -->
          <!-- <ng-container matColumnDef="business_objective">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Business Goals </th>
                                <td mat-cell *matCellDef="let planogram">
                                    {{getAllBusinessObjectives(planogram.business_objective)}} </td>
                            </ng-container> -->

          <!-- Created By Column -->
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field *ngIf="createdDates.length > 0">
                <mat-label>Created On</mat-label>
                <mat-select
                  value="planogram_list_form_group['created_at'].value"
                  formControlName="created_at"
                  multiple
                >
                  <mat-option
                    (click)="toggleSelection(date, 'created_at', 4)"
                    *ngFor="let date of createdDates"
                    [value]="date"
                  >
                    {{ date }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let planogram">
              {{ planogram.created_at }}
            </td>
          </ng-container>

          <ng-container *ngIf="isUserAdmin == 1" matColumnDef="created_by">
            <th mat-header-cell *matHeaderCellDef>Created By</th>
            <td mat-cell *matCellDef="let planogram">
              {{ planogram.created_by }}
            </td>
          </ng-container>

          <!-- Business Goals Column -->
          <ng-container matColumnDef="progress_status">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field *ngIf="status.length > 0">
                <mat-label>Created On</mat-label>
                <mat-select
                  value="planogram_list_form_group['status'].value"
                  formControlName="status"
                  multiple
                >
                  <mat-option
                    (click)="toggleSelection(s, 'status', 5)"
                    *ngFor="let s of status"
                    [value]="s"
                  >
                    {{ s }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let planogram">
              <span
                class="planogram-status"
                [ngClass]="{
                  active:
                    planogram.progress_status === CONFIG.PLANOGRAMSTATUS.ACTIVE,
                  inactive:
                    planogram.progress_status ===
                    CONFIG.PLANOGRAMSTATUS.INACTIVE,
                  draft:
                    planogram.progress_status === CONFIG.PLANOGRAMSTATUS.DRAFT
                }"
              >
                {{ planogram.progress_status }}
              </span>
            </td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th
              style="padding-right: 10px; width: 6.5vw"
              mat-header-cell
              *matHeaderCellDef
            ></th>
            <td
              style="padding-right: 10px"
              mat-cell
              *matCellDef="let planogram"
              [ngClass]="
                planogram.can_edit ? 'action-link' : 'action-link-disabled'
              "
            >
              <!-- <em class="bi bi-view" style="margin-right: 10px;" ></i> -->
              <em
                class="bi bi-pencil"
                style="
                  margin-right: 20px;
                  color: #e61a27;
                  font-size: 1.3vw;
                  font-weight: 500;
                "
              ></em>
              <!-- <em class="bi bi-files" style="margin-right: 10px;color:#E61A27;" (click)="copyPlanogram($event, planogram.id, planogram.name)" ></em> -->
              <em
                class="bi bi-trash"
                style="color: #e61a27; font-size: 1.3vw; font-weight: 500"
                (click)="handleDeleteClick($event, planogram.id)"
              ></em>
              <!-- <em class="bi bi-three-dots-vertical" (click)="$event.stopPropagation()"
                                        [matMenuTriggerFor]="menu"></i> -->
              <mat-menu
                xPosition="before"
                #menu="matMenu"
                class="more-action-menu"
                screen_index
              >
                <button
                  class="action-button"
                  mat-menu-item
                  (click)="handleDeleteClick($event, planogram.id)"
                >
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <!-- (click)="handleRowClick(row)" -->
          <tr
            mat-header-row
            *matHeaderRowDef="
              isUserAdmin == 1
                ? displayedColumnsForAdmin
                : displayedColumnsForUser;
              sticky: true
            "
          ></tr>
          <tr
            mat-row
            *matRowDef="
              let row;
              columns: isUserAdmin == 1
                ? displayedColumnsForAdmin
                : displayedColumnsForUser
            "
            (click)="active_tab === tabs[1].name ? handleRowClick(row) : null"
          ></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="6">
              No data matching with the filter
            </td>
          </tr>
        </table>
        <div
          style="
            font-size: 0.95vw;
            font-weight: 500;
            display: flex;
            justify-content: center;
            align-items: center;
          "
          *ngIf="filtered_planogram_list && filtered_planogram_list.length == 0"
        >
          No data matching with the filter
        </div>

        <mat-paginator
          *ngIf="planogram_list && planogram_list.length > 0"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          hidePageSize="true"
          showFirstLastButtons="false"
          (page)="paginationChange($event)"
          aria-label="Select page of Planograms"
          class="planogram-list-paginator"
          [length]="filtered_planogram_list.length"
        >
        </mat-paginator>
      </div>
    </div>
  </div>
  <!-- </mat-grid-tile>


        <mat-grid-tile colspan="1">
            <div id="quick-actions">
                <h4>Quick Actions</h4>
                <div>
                    <button mat-button color="warn" (click)="addNewPlanogram()">
                        <em class="bi bi-plus-circle-fill"></i>
                        New Planogram
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-button color="warn" (click)="openComparePlanogramDialog()">
                        <em class="bi bi-eye"></i>
                        Compare Planograms</button>
                </div>
            </div>

        </mat-grid-tile>

    </mat-grid-list> -->
</div>

<app-loader [is_show_loader]="(loader | async)! || is_show_loader"></app-loader>
